import { render } from "./CreateInstanceMultiStep.vue?vue&type=template&id=451052e2"
import script from "./CreateInstanceMultiStep.vue?vue&type=script&lang=js"
export * from "./CreateInstanceMultiStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__